import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import './OnboardingEventConfigDetailPage.css'
import './OnboardingEventConfigPage.css'

const OnboardingEventConfigAddPageUI = ({
    context, eventDetails, loading, errorList,
    submitting, submitError, onInputChange, onSubmit, onCancel,
    errors, isFormValid
}) => {
    return (
        <SuperUserSettingsPageUI context={context} className='pg_su_onboarding_events_edit'>
            <div className='g_spacer_20'></div>

            <div className='g_flex_h g_flex_at_center g_flex_space_between header-section'>
                <h2 className='page-title'>Onboarding Event Configuration</h2>
            </div>

            <div className='detail-container'>
                <div className='detail-header g_flex_h g_flex_at_center g_flex_space_between'>
                    <h3>Add New</h3>
                    <i className='icon-times close-icon' onClick={onCancel}></i>
                </div>

                <div className='detail-body'>
                    {loading && <SpinnerComponentUI />}
                    {errorList && errorList.length > 0 && <GenericErrorUI error={errorList[0]} />}
                    {submitError && <div className="alert alert-danger">{submitError}</div>}

                    {!loading && eventDetails && (
                        <React.Fragment>
                            {/* Event Information */}
                            {(() => {
                                const isSpecialEvent = eventDetails.eventCode === 'WAITING_SCREEN' || eventDetails.eventCode === 'BANK_DATA_COLLECTED';
                                return (
                                    <>
                                        <div className='section'>
                                            <h4 className='section-title'>Event Information</h4>
                                            <div className='row'>
                                                <FormInput label='Event Name*' value={eventDetails.eventName} onChange={(val) => onInputChange('eventName', val)} maxLength={50} error={errors && errors.eventName} />
                                                <FormSelect label='Event Code*' value={eventDetails.eventCode} onChange={(val) => onInputChange('eventCode', val)} options={EVENT_CODE_OPTIONS} error={errors && errors.eventCode} />
                                                {eventDetails.eventCode !== 'PAN_AWAITED' && (
                                                    <FormInput label='Template ID (WhatsApp)*' value={eventDetails.whatsappTemplateName} onChange={(val) => onInputChange('whatsappTemplateName', val)} maxLength={50} error={errors && errors.whatsappTemplateName} />
                                                )}
                                            </div>
                                            {!isSpecialEvent && (
                                                <div className='row mt-3'>
                                                    <FormInput label='Email Body Text*' value={eventDetails.messageBodyText} onChange={(val) => onInputChange('messageBodyText', val)} fullWidth textarea maxLength={1000} error={errors && errors.messageBodyText} />
                                                </div>
                                            )}
                                        </div>

                                        {!isSpecialEvent && (
                                            <>
                                                <div className='divider'></div>

                                                {/* Notification Settings */}
                                                <div className='section'>
                                                    <h4 className='section-title'>Notification Settings</h4>

                                                    {eventDetails.eventCode !== 'PAN_AWAITED' && (
                                                        <div className='col-2'>
                                                            <h5 className='sub-section-title'>WhatsApp Settings</h5>
                                                            <div className='row'>
                                                                <FormInput label='WhatsApp Frequency (Hours)*' value={eventDetails.whatsappFrequencyDays} onChange={(val) => onInputChange('whatsappFrequencyDays', val)} type="number" />
                                                                <FormInput label='Max WhatsApp Count*' value={eventDetails.maxWhatsappCount} onChange={(val) => onInputChange('maxWhatsappCount', val)} type="number" />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className='col-2'>
                                                        <h5 className='sub-section-title'>Email Settings</h5>
                                                        <div className='row'>
                                                            <FormInput label='Email Frequency (Hours)*' value={eventDetails.emailFrequencyDays} onChange={(val) => onInputChange('emailFrequencyDays', val)} type="number" />
                                                            <FormInput label='Max Email Count*' value={eventDetails.maxEmailCount} onChange={(val) => onInputChange('maxEmailCount', val)} type="number" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='divider'></div>

                                                {/* Escalation Settings */}
                                                <div className='section'>
                                                    <h4 className='section-title'>Escalation Settings</h4>
                                                    <div className='mb-3'>
                                                        <FormCheckbox label='Escalation Required' checked={eventDetails.escalationRequired} onChange={(val) => onInputChange('escalationRequired', val)} />
                                                        <div className='row col-2'>
                                                            <FormInput label={eventDetails.escalationRequired ? 'Escalation After Reminders*' : 'Escalation After Reminders'} value={eventDetails.escalationAfterReminders} onChange={(val) => onInputChange('escalationAfterReminders', val)} type="number" error={errors && errors.escalationAfterReminders} />
                                                            <FormInput label={eventDetails.escalationRequired ? 'Escalation Email*' : 'Escalation Email'} value={eventDetails.escalationEmail} onChange={(val) => onInputChange('escalationEmail', val)} error={errors && errors.escalationEmail} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='divider'></div>
                                            </>
                                        )}

                                        {/* Other Settings */}
                                        <div className='section'>
                                            <h4 className='section-title'>Other Settings</h4>
                                            <div className='row'>
                                                {!isSpecialEvent && (
                                                    <FormInput label={eventDetails.isActive ? 'Cool Off Period (Min)*' : 'Cool Off Period (Min)'} value={eventDetails.coolOffPeriodMin} onChange={(val) => onInputChange('coolOffPeriodMin', val)} type="number" />
                                                ) || <div style={{ width: '20px' }}></div>}
                                                <FormCheckbox label='Is Active' checked={eventDetails.isActive} onChange={(val) => onInputChange('isActive', val)} />
                                            </div>
                                        </div>
                                    </>
                                )
                            })()}

                            <div className='g_flex_h g_flex_justify_end mt-4'>
                                <button className='btn btn-primary' onClick={onSubmit} disabled={submitting || !isFormValid}>
                                    {submitting ? 'Saving...' : 'Save'}
                                </button>
                            </div>

                        </React.Fragment>
                    )}
                </div>
            </div>
        </SuperUserSettingsPageUI>
    )
}

const FormInput = ({ label, value, onChange, fullWidth, textarea, type = 'text', readOnly, maxLength, disabled, error }) => (
    <div className={`detail-item ${fullWidth ? 'col-12' : 'col-4'}`}>
        <label className='detail-label'>{label}</label>
        {textarea ? (
            <textarea
                className={`form-control custom-input ${error ? 'is-invalid' : ''}`}
                style={{
                    width: '80%',
                    maxWidth: '100%',
                }}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                readOnly={readOnly}
                disabled={disabled}
                rows={10}
                maxLength={maxLength}
            />
        ) : (
            <input
                type={type}
                className={`form-control custom-input ${error ? 'is-invalid' : ''}`}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                readOnly={readOnly}
                disabled={disabled}
                maxLength={maxLength}
                min={0}
                onKeyDown={(e) => {
                    if (type === 'number' && (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-' || e.key === '.')) {
                        e.preventDefault();
                    }
                }}
            />
        )}
        {error && <div className="invalid-feedback" style={{ display: 'block' }}>{error}</div>}
    </div>
)

const FormSelect = ({ label, value, onChange, options }) => (
    <div className='detail-item col-3'>
        <label className='detail-label'>{label}</label>
        <select
            className='form-control custom-input'
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
        >
            <option value="">Select...</option>
            {options.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
        </select>
    </div>
)

const FormCheckbox = ({ label, checked, onChange }) => (
    <div className='detail-item col-1'>
        <label className='detail-label' style={{ display: 'block' }}>{label}</label>
        <div className="g_flex_h g_flex_ac">
            <div className={`custom-checkbox ${checked ? 'checked' : ''}`} onClick={() => onChange(!checked)}>
                {checked && <i className="icon-check"></i>}
            </div>
            <span className="checkbox-label" style={{ marginLeft: '10px' }}>{checked ? 'Yes' : 'No'}</span>
        </div>
    </div>
)

const EVENT_CODE_OPTIONS = [
    { value: 'PAN_AWAITED', label: 'PAN_AWAITED' },
    { value: 'PROVISIONAL_STATEMENT_AWAITED', label: 'PROVISIONAL_STATEMENT_AWAITED' },
    { value: 'LOAN_DETAIL_AWAITED', label: 'LOAN_DETAIL_AWAITED' },
    { value: 'PROJECT_DETAIL_AWAITED', label: 'PROJECT_DETAIL_AWAITED' },
    { value: 'WAITING_SCREEN', label: 'WAITING_SCREEN' },
    { value: 'KYC_AWAITED', label: 'KYC_AWAITED' },
    { value: 'GST_AWAITED', label: 'GST_AWAITED' },
    { value: 'ITR_AWAITED', label: 'ITR_AWAITED' },
    { value: 'BANK_STATEMENT_AWAITED', label: 'BANK_STATEMENT_AWAITED' },
    { value: 'BANK_DATA_COLLECTED', label: 'BANK_DATA_COLLECTED' }
]

export default OnboardingEventConfigAddPageUI
